import Gravity from '../../../../../gravity-global/assets/js/global-functions';
import { addSlidesTabIndex } from '../../../../../gravity-global/assets/js/helpers/swiper/add-slides-tab-index';

const textButtonCarouselInit = () => {
    document
        .querySelectorAll('.gg-carousel-with-text-and-button .wp-block-statik-slider > .swiper')
        /* eslint-disable */
        .forEach((textButtonCarousel) => {
            textButtonCarousel.swiper.params.watchSlidesProgress = true;
            textButtonCarousel.swiper.params.grabCursor = true;
            textButtonCarousel.swiper.params.observer = true;
            textButtonCarousel.swiper.params.observerParents = true;
            textButtonCarousel.swiper.params.breakpoints = {
                0: {
                    spaceBetween: 0,
                },
                1025: {
                    spaceBetween: 48,
                },
            };

            textButtonCarousel.swiper.update();

            addSlidesTabIndex(textButtonCarousel.swiper);

            textButtonCarousel.swiper.on('slideChange', () => {
                addSlidesTabIndex(textButtonCarousel.swiper);
            });
        });
};

Gravity.ready(textButtonCarouselInit);
